import { Component, ContentChild, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core'
import { Dialog } from 'primeng/dialog'
import { DRAWER_TRANSITION_OPTIONS, MODAL_TRANSITION_OPTIONS } from '../../animations/motion.tokens'
import { ButtonColor, ButtonVariant } from 'src/app/domain/enums/components/button.enum'
import { DialogPosition, DialogSize } from 'src/app/domain/enums/components/dialog.enum'
import { PrimeIcon } from 'src/app/domain/enums/components/prime-icons.enum'

@Component({ selector: 'app-dialog', templateUrl: './dialog.component.html', styleUrls: ['./dialog.component.scss'] })
export class DialogComponent implements OnChanges {
  @Input() showDialog: boolean = false
  @Input() title: string = 'Modal'
  @Input() iconConfirmButton: PrimeIcon = PrimeIcon.CHECK
  @Input() labelConfirmButton: string = 'Confirmar'
  @Input() disabledConfirmButton: boolean = false
  @Input() size: DialogSize = DialogSize.SMALL
  @Input() hasFooter: boolean = true
  @Input() showConfirmButton: boolean = true
  @Input() isLockActions: boolean = false
  @Input() isMaximizable: boolean = true
  @Input() callbackConfirmButton: Function = () => {}
  @Input() callbackCloseButton: Function = () => {}
  @Input() openFullScreen: boolean = false
  @Input() hasScroll: boolean = true
  @Input() isClosable: boolean = true
  @Input() showCancelButton: boolean = false
  @Input() position: DialogPosition = DialogPosition.CENTER
  @Input() hasFullHeight: boolean = false
  @Input() isDrawer: boolean = false

  @Output() hideDialog: EventEmitter<boolean> = new EventEmitter()

  @ViewChild('dialog') dialog!: Dialog
  @ContentChild('header', { read: ElementRef }) headerContent!: ElementRef

  isMaximized: boolean = false

  callbackHideDialog: Function = () => this.changeHideDialog()

  buttonVariant = ButtonVariant
  buttonColor = ButtonColor
  dialogPosition = DialogPosition

  get transitionOptions(): string {
    return this.isDrawer ? DRAWER_TRANSITION_OPTIONS : MODAL_TRANSITION_OPTIONS
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['showDialog'] && changes['showDialog'].currentValue !== undefined) this.showDialog = changes['showDialog'].currentValue
    if (changes['showDialog'] && changes['showDialog'].currentValue && this.openFullScreen) this.toggleMaximize(this.dialog)
    if (changes['showDialog'] && changes['showDialog'].currentValue === false) this.resetMaximizeState()
  }

  public changeVisibleDialog(visible: boolean): void {
    if (visible === this.showDialog) return
    if (!visible) this.changeHideDialog()
    else this.showDialog = visible
  }

  public changeHideDialog(): void {
    this.callbackCloseButton()
    this.resetMaximizeState()
    this.showDialog = false
    this.hideDialog.emit(!this.showDialog)
  }

  toggleMaximize(dialog: Dialog) {
    dialog.maximize()
    this.isMaximized = !this.isMaximized
  }

  private resetMaximizeState(): void {
    if (this.isMaximized && this.dialog) {
      this.dialog.maximize()
      this.isMaximized = false
    }
  }
}
